import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { CSVDownloadIcon } from './icons';
import { downloadEmployeeCSV } from './query-request';

class EmployeeCSVDownload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  handleDownload = async () => {
    const { tenantId } = this.props;
    if (!tenantId) {
      console.error('tenantId is required');
      return;
    }

    this.setState({ loading: true });
    try {
      await downloadEmployeeCSV({ tenantId });
    } catch (error) {
      console.error('Error downloading CSV:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading } = this.state;

    return (
      <Button
        type="button"
        severity="info"
        className="submit-button csv-download"
        disabled={loading}
        onClick={this.handleDownload}
      >
        <>
          <CSVDownloadIcon />
          <span>CSVダウンロード</span>
        </>
      </Button>
    );
  }
}

export default EmployeeCSVDownload;
